<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ data.title | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onCancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="nameControl" class="name-input-dialog__form">
      <div class="name-input-dialog__field">
        <label class="name-input-dialog__label">{{ 'footers.name' | translate }}</label>
        <mat-form-field appearance="outline">
          <input matInput
                 formControlName="name"
                 [placeholder]="data.placeholder || ('footers.name' | translate)"
                 type="text"
                 [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="nameControl.hasError('required', ['name'])">
            {{ 'fieldRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="onCancel()">
      {{ 'cancel' | translate }}
    </button>
    <button mat-raised-button
            color="primary"
            type="button"
            (click)="onConfirm()">
      {{ data.actionType === 'saveAndInstall' ? (data.saveAndInstallButtonText || ('saveAndInstall' | translate)) : (data.saveButtonText || ('save' | translate)) }}
    </button>
  </footer>
</div>
